module.exports = __webpack_public_path__ + "img/contract.77194b9d.svg";